import classNames from "classnames";

const BannerImage = ({ url, className }) => {
  if (!url) return null;

  return (
    <figure className={classNames("theme-image-container", className)}>
      <img src={url} className="image-full-width" alt="" />
    </figure>
  );
};

export default BannerImage;
